import Phaser from 'phaser';
import { GEODE_FRAME } from '../../constants';
import { GEODE_DEFS, geodeCrackSheetKey } from '../../geode';
import type { GeodeModel } from '../types';
import { prepareGeodeBreakAnim, queueGeodeBreakLoad } from './geode-break';

export function queueGeodeLoad(scene: Phaser.Scene, model: GeodeModel) {
  scene.load.image('geode-shadow', 'Misc/Shadow.png');

  const def = GEODE_DEFS[model.type];
  if (def) {
    const sheetKey = geodeCrackSheetKey(model.type);
    if (!scene.textures.exists(sheetKey)) {
      scene.load.spritesheet(sheetKey, `${def.path}${def.crackSheet}`, {
        frameWidth: def.frameWidth,
        frameHeight: GEODE_FRAME,
        endFrame: def.frames - 1,
      });
    }
    queueGeodeBreakLoad(scene, model.type);
  }

  for (let i = 1; i <= 8; i++) {
    scene.load.image(`smash-piece-${i}`, `Misc/Smash Pieces/Dust Smash/${i}.png`);
  }

  for (let i = 1; i <= 5; i++) {
    scene.load.image(`dust-drop-${i}`, `Misc/Dust drop/Dust ${i}.png`);
  }
  scene.load.image('drop-stone', 'Crafting/stone.png');
  scene.load.image('drop-leather', 'Crafting/leather.png');
  scene.load.image('drop-claws', 'Crafting/claws.png');
  scene.load.image('drop-pink-fur', 'Crafting/pink_fur.png');
}

export function prepareGeode(scene: Phaser.Scene, model: GeodeModel) {
  prepareGeodeBreakAnim(scene, model.type);
}
